"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ETH_TOKEN_TICKERS = void 0;
const ticker_1 = require("./ticker");
exports.ETH_TOKEN_TICKERS = [
    ticker_1.Ticker.USDT,
    ticker_1.Ticker.WBTC,
    ticker_1.Ticker.BUSD,
    ticker_1.Ticker.HEX,
    ticker_1.Ticker.LINK,
    ticker_1.Ticker.UNI,
    ticker_1.Ticker.USDC,
    ticker_1.Ticker['1INCH'],
    ticker_1.Ticker.AAVE,
    ticker_1.Ticker.TLM,
    ticker_1.Ticker.ATA,
    ticker_1.Ticker.CHZ,
    ticker_1.Ticker.COMP,
    ticker_1.Ticker.FTM,
    ticker_1.Ticker.GRT,
    ticker_1.Ticker.KNC,
    ticker_1.Ticker.MATIC,
    ticker_1.Ticker.REN,
    ticker_1.Ticker.RSR,
    ticker_1.Ticker.SHIB,
    ticker_1.Ticker.SUSHI,
    ticker_1.Ticker.SNX,
    ticker_1.Ticker.TUSD,
    ticker_1.Ticker.YFI,
    ticker_1.Ticker.PLA,
    ticker_1.Ticker.ZEDXION,
    ticker_1.Ticker.ZEDXIONC,
    ticker_1.Ticker.IMX,
    ticker_1.Ticker.CRV,
    ticker_1.Ticker.APE,
    ticker_1.Ticker.DYDX,
    ticker_1.Ticker.LIT,
    ticker_1.Ticker.SAND,
    ticker_1.Ticker.STR,
    ticker_1.Ticker.PEPE
];
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZXRoLXRva2VuLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3RpY2tlcnMvZXRoLXRva2VuLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUVBLHFDQUFpQztBQUVwQixRQUFBLGlCQUFpQixHQUFHO0lBQy9CLGVBQU0sQ0FBQyxJQUFJO0lBQ1gsZUFBTSxDQUFDLElBQUk7SUFDWCxlQUFNLENBQUMsSUFBSTtJQUNYLGVBQU0sQ0FBQyxHQUFHO0lBQ1YsZUFBTSxDQUFDLElBQUk7SUFDWCxlQUFNLENBQUMsR0FBRztJQUNWLGVBQU0sQ0FBQyxJQUFJO0lBQ1gsZUFBTSxDQUFDLE9BQU8sQ0FBQztJQUNmLGVBQU0sQ0FBQyxJQUFJO0lBQ1gsZUFBTSxDQUFDLEdBQUc7SUFDVixlQUFNLENBQUMsR0FBRztJQUNWLGVBQU0sQ0FBQyxHQUFHO0lBQ1YsZUFBTSxDQUFDLElBQUk7SUFDWCxlQUFNLENBQUMsR0FBRztJQUNWLGVBQU0sQ0FBQyxHQUFHO0lBQ1YsZUFBTSxDQUFDLEdBQUc7SUFDVixlQUFNLENBQUMsS0FBSztJQUNaLGVBQU0sQ0FBQyxHQUFHO0lBQ1YsZUFBTSxDQUFDLEdBQUc7SUFDVixlQUFNLENBQUMsSUFBSTtJQUNYLGVBQU0sQ0FBQyxLQUFLO0lBQ1osZUFBTSxDQUFDLEdBQUc7SUFDVixlQUFNLENBQUMsSUFBSTtJQUNYLGVBQU0sQ0FBQyxHQUFHO0lBQ1YsZUFBTSxDQUFDLEdBQUc7SUFDVixlQUFNLENBQUMsT0FBTztJQUNkLGVBQU0sQ0FBQyxRQUFRO0lBQ2YsZUFBTSxDQUFDLEdBQUc7SUFDVixlQUFNLENBQUMsR0FBRztJQUNWLGVBQU0sQ0FBQyxHQUFHO0lBQ1YsZUFBTSxDQUFDLElBQUk7SUFDWCxlQUFNLENBQUMsR0FBRztJQUNWLGVBQU0sQ0FBQyxJQUFJO0lBQ1gsZUFBTSxDQUFDLEdBQUc7SUFDVixlQUFNLENBQUMsSUFBSTtDQUNaLENBQUEifQ==